import { Loading3QuartersOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { ReactNode } from 'react'

interface IProps {
  loading?: boolean
  children?: ReactNode
  fontSize?: number
}
const SpinLoading = ({ loading, children, fontSize = 36 }: IProps) => {
  const antIcon = (
    <Loading3QuartersOutlined style={{ fontSize: fontSize }} spin />
  )
  return (
    <>
      <Spin indicator={antIcon} spinning={loading}>
        {children}
      </Spin>
    </>
  )
}

export default SpinLoading
